import { SiteGroupSiteDetail } from '@m/types/api';
import { apiFetch } from '@m/utils/http';
import { useQuery } from '@tanstack/react-query';
import { LocationGroupService } from 'apps/admin/services';

export const useSiteGroupSitesWithLanes = (id: number) =>
  useQuery({
    queryKey: ['siteGroupSites', id],
    queryFn: async () => {
      const { data = [] } = await apiFetch<SiteGroupSiteDetail[]>(`/admin/site-group/${id}/list`);
      return data;
    },
    enabled: !!id,
  });

export const useLocationGroupQuery = (locationGroupId: number) =>
  useQuery({
    queryKey: ['siteGroup', locationGroupId],
    queryFn: async () => {
      const { data, success } = await LocationGroupService.getLocationGroup(locationGroupId);
      if (!success || !data) {
        throw new Error('Unable to fetch location');
      }
      return data;
    },
    enabled: !!locationGroupId,
  });

export const useGetSiteGroupForSiteQuery = (zoneId: number) =>
  useQuery({
    queryKey: ['siteGroupForSite', zoneId],
    queryFn: async () => {
      const { success, data } = await LocationGroupService.getLocationGroupForSite({
        siteId: zoneId,
      });
      if (success) {
        return data;
      }
      return null;
    },
    enabled: !!zoneId,
  });
